/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { InventoryImage } from 'sarsaparilla';
import { Lottery } from '../types/lottery';

interface LotteryImageProps {
    lottery: Lottery;
}
export default function LotteryImage({ lottery }: LotteryImageProps) {
    let image = null;

    switch (lottery.inventory_info.facility_type) {
        case 'permit':
        case 'ticket':
        case 'campground':
            image = (
                <InventoryImage
                    id={lottery.inventory_id}
                    type="asset"
                    hasFauxImageRatio="860:222"
                />
            );
            break;
        default:
            image = (
                <InventoryImage
                    id={lottery.inventory_id}
                    type={lottery.inventory_info.facility_type}
                    hasFauxImageRatio="860:222"
                />
            );
            break;
    }
    return image;
}
